const chains = [];
chains.push({ _operation: 'getPaymentSystemStatementDetailsById', api: '/payment-system-statement-details/:objectId', defaultData: [], httpVerb: 'get' });
export default chains;
